import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.title',
    defaultMessage: 'Contato',
  },
  type: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.type',
    defaultMessage: 'Tipo de contato',
  },
  name: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.name',
    defaultMessage: 'Nome',
  },
  areaCode: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.areaCode',
    defaultMessage: 'DDD',
  },
  phoneNumber: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.phoneNumber',
    defaultMessage: 'Telefone',
  },
  optional: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.optional',
    defaultMessage: '(opcional)',
  },
  sindico: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.sindico',
    defaultMessage: 'Síndico',
  },
  porteiro: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.porteiro',
    defaultMessage: 'Porteiro',
  },
  administradora: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.administradora',
    defaultMessage: 'Administradora',
  },
  selectPlaceholder: {
    id: 'app.containers.Checklist.ExternalArea.Contacts.select.placeholder',
    defaultMessage: 'Selecione aqui',
  },
});
